export const industryLanguagesData = {
  title: "Expert translation in 100+ languages",
  description:
    "We offer the most elite network of vetted and specialized automotive translators for exceptional accuracy.",
  languages: [
    { name: "Spanish", link: "/languages/spanish" },
    { name: "Arabic", link: "/languages/arabic" },
    { name: "French", link: "/languages/french" },
    { name: "Italian", link: "/languages/italian" },
    { name: "German", link: "/languages/german" },
    { name: "Chinese", link: "/languages/chinese" },
    { name: "Brazilian", link: "/languages/brazilian-portuguese" },
    { name: "Japanese", link: "/languages/japanese" },
    { name: "Indonesia", link: "/languages/indonesian" },
  ],
  exploreText: "Explore all",
};
